import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';

const BuscaSecoes = (props) => {
    return (              
        <div className="bloco-dados busca-context flex">                   
            <div className="w-full">                    
                <div className="p-inputgroup">                      

                    <Button icon="pi pi-search" 
                        className="p-button-info text-white pesquisa-botao-limpa" 
                        onClick={props?.iniciaBusca}/>

                    <InputText className="serch-secoes" 
                        onKeyDown={(e) => props?.handleKey(e)} 
                        placeholder="Pesquisa por Seções" ref={props?.searchField}/>         

                    <Button icon="pi pi-times" className="p-button-info text-white pesquisa-botao-limpa" 
                        label="Limpar" aria-label="Limpar" onClick={props?.limpaFiltro}/>

                </div>
            </div>                    
        </div>        
    );
}

export default BuscaSecoes;